import React, { useState, useEffect } from 'react';
import { RefreshCcw, ChevronRight } from 'lucide-react';
import { getCopilotValueByTaskIdApi } from '@/api/copilot';
import { EXTERNAL_USER_ID } from '@/config/env';
import marketIcon from '@/imgs/market-icon.png';
const MarketOverview: React.FC<{ taskId: string }> = ({ taskId }) => {
  // 市场数据配置
  const markets = [
    { key: 'hs', name: '沪深', data: '沪深市场数据' },
    { key: 'hk', name: '港股', data: '港股市场数据' },
    { key: 'us', name: '美股', data: '美股市场数据' }
  ];

  // 当前激活的市场索引
  const [activeMarket, setActiveMarket] = useState(0);
  const [loading, setLoading] = useState(true);

  // 获取Copilot数据
  const fetchCopilotData = async () => {
    try {
      setLoading(true);

      // todo 先不请求接口
      if (taskId) {
        return;
      }

      const pUseAll = [5, 6].map(reqType => {
        return getCopilotValueByTaskIdApi({
          externalUserId: EXTERNAL_USER_ID,
          reqType,
          taskId
        });
      });

      Promise.allSettled(pUseAll).then(results => {
        console.log('获取Copilot数据成功:', results);
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            console.log(result.value);
          }
        });
      });
    } catch (error) {
      console.error('获取Copilot数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (taskId) {
      fetchCopilotData();
    }
  }, [taskId]);

  // 切换市场的方法
  const switchMarket = (index: number) => {
    setActiveMarket(index);
    // 这里可以根据选中的市场加载对应的数据
    console.log('切换到市场:', markets[index].name);
  };

  return (
    <div className="space-y-3">
      {/* 标题区域 */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <div className="h-6 w-6">
            <img src={marketIcon} alt="市场" className="h-full w-full object-cover" />
          </div>
          <span className="text-base font-semibold text-black">市场动态</span>
        </div>
        <div className="h-4 w-4 cursor-pointer">
          <RefreshCcw className="h-full w-full" />
        </div>
      </div>

      {/* 今日大盘指数 */}
      <div className="rounded-lg bg-white p-3">
        <div className="rounded-lg border border-gray-100 p-3">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-sm font-semibold text-gray-800">今日大盘指数</span>
            {/* 指数选择器 */}
            <div className="rounded bg-gray-100 px-1 py-0.5">
              <div className="relative">
                {/* 背景滑块 */}
                <div
                  className="absolute bottom-0.5 top-0.5 rounded bg-white transition-all duration-300 ease-in-out"
                  style={{
                    left: `${activeMarket * 33.33}%`,
                    width: '33.33%'
                  }}
                />

                {/* Tab按钮 */}
                {markets.map((market, index) => (
                  <button
                    key={market.key}
                    className={`relative cursor-pointer rounded px-3 py-1 text-xs transition-all duration-300 ease-in-out ${
                      activeMarket === index ? 'font-medium text-black' : 'text-gray-500'
                    }`}
                    onClick={() => switchMarket(index)}
                  >
                    {market.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* 指数数据 */}
          <div className="mb-3 grid grid-cols-3 gap-2">
            <div className="rounded-md bg-red-50 p-2 text-center">
              <div className="text-sm text-gray-800">道琼斯</div>
              <div className="text-lg font-medium text-red-600">34,567.89</div>
              <div className="text-sm text-red-600">+0.68%</div>
            </div>
            <div className="rounded-md bg-green-50 p-2 text-center">
              <div className="text-sm text-gray-800">纳斯达克</div>
              <div className="text-lg font-medium text-green-600">14,234.67</div>
              <div className="text-sm text-green-600">-0.62%</div>
            </div>
            <div className="rounded-md bg-red-50 p-2 text-center">
              <div className="text-sm text-gray-800">道琼斯</div>
              <div className="text-lg font-medium text-red-600">34,567.89</div>
              <div className="text-sm text-red-600">+0.68%</div>
            </div>
          </div>

          {/* 行业板块 */}
          <div className="mb-3 grid grid-cols-3 gap-2">
            <div className="rounded-md bg-green-50 p-2 text-center">
              <div className="text-sm text-gray-800">科技</div>
              <div className="text-sm text-green-600">-0.62%</div>
            </div>
            <div className="rounded-md bg-red-50 p-2 text-center">
              <div className="text-sm text-gray-800">金融</div>
              <div className="text-sm text-red-600">+0.68%</div>
            </div>
            <div className="rounded-md bg-gray-50 p-2 text-center">
              <div className="text-sm text-gray-800">医疗</div>
              <div className="text-sm text-gray-600">+0.00%</div>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2">
            <div className="rounded-md bg-green-50 p-2 text-center">
              <div className="text-sm text-gray-800">科技</div>
              <div className="text-sm text-green-600">-0.62%</div>
            </div>
            <div className="rounded-md bg-red-50 p-2 text-center">
              <div className="text-sm text-gray-800">金融</div>
              <div className="text-sm text-red-600">+0.68%</div>
            </div>
            <div className="rounded-md bg-red-50 p-2 text-center">
              <div className="text-sm text-gray-800">金融</div>
              <div className="text-sm text-red-600">+0.68%</div>
            </div>
          </div>
        </div>
      </div>

      {/* 今日热门资讯 */}
      <div className="rounded-lg bg-white p-3">
        <div className="rounded-lg border border-gray-100 p-3">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-sm font-semibold text-gray-800">今日热门资讯</span>
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-800">实时更新</span>
              <div className="h-4 w-4 cursor-pointer">
                <RefreshCcw className="h-full w-full" />
              </div>
            </div>
          </div>

          {/* 资讯列表 */}
          <div className="space-y-2">
            <div className="rounded-md bg-purple-50 p-2">
              <div className="mb-1 text-sm text-gray-800">
                央行宣布降准0.25个百分点，释放流动性约5000亿元财经网
              </div>
              <div className="text-xs text-gray-500">2小时前</div>
            </div>
            <div className="rounded-md bg-purple-50 p-2">
              <div className="mb-1 text-sm text-gray-800">
                新能源汽车销量再创新高，多家企业上调全年销售目标证券日报
              </div>
              <div className="text-xs text-gray-500">3小时前</div>
            </div>
            <div className="rounded-md bg-purple-50 p-2">
              <div className="mb-1 text-sm text-gray-800">
                新能源汽车销量再创新高，多家企业上调全年销售目标证券日报
              </div>
              <div className="text-xs text-gray-500">4小时前</div>
            </div>
          </div>

          {/* 查看更多 */}
          <div className="mt-3 flex items-center justify-center gap-2">
            <span className="text-sm text-gray-800">查看更多资讯</span>
            <div className="h-4 w-4 cursor-pointer">
              <ChevronRight className="h-full w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketOverview;
